'use client';
import { useEffect, useState } from 'react';
import { requestPhoneTilt } from './phone-tilt.js';
import LiquidGlass from './liquid-glass';

export default function PhoneTiltControl({visible}: {visible: boolean}) {
  const [supported, setSupported] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [pending, setPending] = useState(false);
  const [message, setMessage] = useState('');
  useEffect(() => {
    const frame = requestAnimationFrame(() => setSupported(Boolean(
      window.isSecureContext && window.matchMedia('(pointer: coarse)').matches
      && window.DeviceOrientationEvent,
    )));
    return () => cancelAnimationFrame(frame);
  }, []);
  async function enable() {
    if (pending) return;
    setPending(true);
    setMessage('');
    // Invoke immediately inside the tap, before awaiting anything else.
    const granted = await requestPhoneTilt();
    setEnabled(granted);
    setPending(false);
    if (!granted) setMessage('Motion access was not enabled.');
  }
  if (!visible || !supported || enabled) return null;
  return <div className="phone-tilt-control">
    <button type="button" className="glass-surface" onClick={enable} disabled={pending} aria-label="Enable phone tilt">
      <LiquidGlass />
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><rect x="7" y="3" width="10" height="18" rx="2" transform="rotate(-12 12 12)"/><path d="M2 8l2-3 2 3M22 16l-2 3-2-3"/></svg>
      <span>{pending ? 'Enabling tilt…' : 'Enable tilt'}</span>
    </button>
    <output aria-live="polite">{message}</output>
  </div>;
}
